import { Component, Element, Event, EventEmitter, Host, JSX, Listen, Prop, h } from '@stencil/core'

import { SelectOption, SelectOptionValue } from './air-select-option.types'
import { KeyCode } from '../../enums/keycode.enum'

@Component({
  tag: 'air-select-option',
  styleUrl: 'air-select-option.scss',
  shadow: true,
})
export class AirSelectOption {
  /** Reference to the host element */
  @Element() host!: HTMLAirSelectOptionElement

  /** Name which will be displayed when option selected */
  @Prop() label?: string

  /** Defines select option value */
  @Prop() value!: SelectOptionValue

  /** Specifies if select option disabled */
  @Prop() disabled = false

  /** Specifies if select option is selected */
  @Prop() selected = false

  /** Triggers when select option is selected */
  @Event({ eventName: 'air-change-option' }) selectOption!: EventEmitter<SelectOption>

  @Listen('click', { passive: true })
  listenClick(event: MouseEvent): void {
    event.stopPropagation()
    if (this.disabled) return
    this.selectOption.emit({
      label: this.label || this.host.textContent,
      value: this.value,
      selected: this.selected,
      disabled: this.disabled,
    })
  }

  @Listen('keydown', { passive: true })
  listenKeyDown(event: KeyboardEvent): void {
    if (this.disabled) return

    const selectKeyCodes: string[] = [KeyCode.Space, KeyCode.Enter]

    if (selectKeyCodes.includes(event.code)) {
      this.selectOption.emit({
        label: this.label || this.host.textContent,
        value: this.value,
        selected: this.selected,
        disabled: this.disabled,
      })
    }
  }

  render(): JSX.Element {
    const attributes = {
      role: 'option',
      'aria-selected': !this.disabled ? `${this.selected}` : false,
      tabindex: this.disabled ? -1 : 0,
      disabled: this.disabled,
    }
    const containerClasses = {
      container: true,
      disabled: this.disabled,
    }
    return (
      <Host {...attributes}>
        <div class={containerClasses}>
          <slot>{this.label || this.value?.toString()}</slot>
        </div>
      </Host>
    )
  }
}
